export enum CompanyFeature {
  proofOfPlay = 'proof_of_play'
}
